import { render, staticRenderFns } from "./bar1.vue?vue&type=template&id=484eedef&scoped=true"
import script from "./bar1.vue?vue&type=script&lang=js"
export * from "./bar1.vue?vue&type=script&lang=js"
import style0 from "./bar1.vue?vue&type=style&index=0&id=484eedef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484eedef",
  null
  
)

export default component.exports